import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PolicyAcceptanceEffects } from './store/policy-acceptance.effects';
import { reducer } from './store/policy-acceptance.reducers';

@NgModule({
  imports: [
    EffectsModule.forFeature([ PolicyAcceptanceEffects ]),
    StoreModule.forFeature('policyAcceptance', reducer),
  ],
})
export class PolicyAcceptanceModule {}
